import axios from 'axios';
import {backendHost} from '../../../../store/config';

const updatePaymentSystemLimit = (params) => {
    return axios.post(`${backendHost}/api/admin/payment/limit`, params);
};

export {
    updatePaymentSystemLimit
}